import { useRouter } from "next/router";
import React, { useState } from "react";
import RequestPhoneCodeForm from "src/components/Authorization/RequestPhoneCodeForm";
import AuthorizationForm from "src/components/Authorization/AuthorizationForm";

interface IAuthorizationProps {
  header: string;
}

const Authorization: React.FunctionComponent<IAuthorizationProps> = ({
  header,
}) => {
  const [phone, setPhone] = useState<string>("");
  const [formSequence, setFormSequence] = useState<"phoneNumber" | "phoneCode">(
    "phoneNumber"
  );
  const router = useRouter();
  const onclick = () => {
    if (formSequence === "phoneNumber") {
      router.push("/");
    } else {
      setFormSequence("phoneNumber");
    }
  };

  return (
    <div>
      <div className="p-4 fixed top-0 right-0 left-0 z-20">
        <div className="flex justify-between">
          <a className="z-10 cursor-pointer" onClick={() => onclick()}>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 20 20"
              fill="#999999"
              className="w-6"
            >
              <path
                fillRule="evenodd"
                d="M12.707 5.293a1 1 0 010 1.414L9.414 10l3.293 3.293a1 1 0 01-1.414 1.414l-4-4a1 1 0 010-1.414l4-4a1 1 0 011.414 0z"
                clipRule="evenodd"
              />
            </svg>
          </a>
        </div>
      </div>
      <div className="mt-20 mx-6">
        <div className="flex flex-col mx-auto max-w-3xl">
          {formSequence === "phoneNumber" ? (
            <RequestPhoneCodeForm
              header={header}
              setPhone={setPhone}
              setFormSequence={setFormSequence}
            />
          ) : (
            <AuthorizationForm
              phone={phone}
              setFormSequence={setFormSequence}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default Authorization;
